module.exports = __webpack_public_path__ + "static/media/Team 8 - Quaranteam.10af8b29.png";